import DepartureDateSidePanelContent from "app/pages/SmartDP/Search/DepartureDateSidePanelContent/DepartureDateSidePanelContent";
import CalendarDisabledView from "app/pages/SmartDP/Search/SDPSearchForm/CalendarDisabledView";
import { FormattedMessage, useIntl } from "react-intl";
import { TravelDatesSelection } from "../../types";

type TravelDatesCalendarProps = {
	value?: TravelDatesSelection;
	hasRequiredData?: boolean;
	onChange?: (value: TravelDatesSelection) => void;
	onConfirm?: (value: TravelDatesSelection) => void;
	minDate?: number;
	maxDate?: number;
	isDisabled?: boolean;
	isDateDisabled: (date?: string | Date | number) => boolean;
};

export const TravelDatesCalendar = ({
	value,
	hasRequiredData = false,
	onChange = () => {},
	onConfirm = () => {},
	minDate,
	maxDate,
	isDisabled = false,
	isDateDisabled,
}: TravelDatesCalendarProps) => {
	const { formatMessage } = useIntl();

	const departureDate = value && value.departureDate;
	const endDate = value && value.endDate;

	return (
		<DepartureDateSidePanelContent
			initialDate={[departureDate, endDate]}
			onDateSelect={date => {
				onChange({
					departureDate: date[0],
					endDate: date[1],
				});
			}}
			onDateConfirm={date => {
				onConfirm({
					departureDate: date[0],
					endDate: date[1],
				});
			}}
			departureDateMin={minDate}
			departureDateMax={maxDate}
			checkDateAvailability={isDateDisabled}
			isCalendarDisabled={isDisabled}
			calendarDisabledView={
				<CalendarDisabledView
					mainMessage={
						hasRequiredData
							? formatMessage({ id: "sdp.calendar.unavailable.date.label" })
							: formatMessage({
									id: "sdp.calendar.no.destination.no.departure.city.label",
							  })
					}
					secondaryMessage={
						hasRequiredData
							? formatMessage({ id: "sdp.calendar.unavailable.date.sublabel" })
							: null
					}
				/>
			}
			displayCalendarIcon={true}
			departureDateLabel={
				<FormattedMessage id="sdp.search.departure.date.side.panel.title" />
			}
			returnDateLabel={<FormattedMessage id="sdp.search.destination.date.side.panel.title" />}
		/>
	);
};
